import { createSelector } from "reselect";

export const getNotifications = (state) => state.notifications;
export const getNumberOfNotifications = createSelector(
  getNotifications,
  (notifications) =>
    notifications.length
);